// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DNvX","rootNoMargin":"styles_rootNoMargin__2V-Bk"};